import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import { useAccountReceivableProvider } from '../Finance.AccountReceivable.Hooks';

export default function FinanceAccountReceivableDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useAccountReceivableProvider();

  if (!selected) return null;

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.displayInfo.title}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
